import React from 'react';
import Radium from 'radium';

import { Formik } from 'formik';
import Yup from 'yup';
import {Input, SubmitButton, RGForm, RadioButton, TextArea, ComboBox} from 'views/FormElements';

import HttpService from 'service/HttpService';

import SessionStore from 'stores/SessionStore';

import Modal from 'react-responsive-modal';
import SelectedImagePreview from 'views/product/SelectedImagePreview';

import AppConstants from 'AppConstants';
import {Separator, A} from 'views/AppElements';
import AppUtil from '../../AppUtil';
import YouTube from 'react-youtube';
import Slider from "react-slick";

import ProductSizeInput from 'views/designer/ProductSizeInput';

const PRODUCT_IMAGES_LMT = 2;
const DIGITAL_ART_IMG_CONSTRAINT = "At least 600px x 600px, Max 50-200 Kb";
const PHOTOGRAPH_IMG_CONSTRAINT = "At least 800px in height or width, Max 50-200 Kb";

const ARTWORK_TYPES = AppConstants.ARTWORK_TYPES;
const PRODUCT_TYPES = AppConstants.PRODUCT_TYPES;


const CANVAS_TO_CASH_VIDEOS = [
						"https://www.youtube.com/watch?v=glAyGdc5pLU", "https://www.youtube.com/watch?v=Uog8mQVfozM", 
						"https://www.youtube.com/watch?v=Em3VXKonS_A", "https://www.youtube.com/watch?v=tK1Ycf_lAFk", 
						"https://www.youtube.com/watch?v=RYFQwOclCmw"];

const DESIGN_VIDEOS = ["https://www.youtube.com/watch?v=0APtVvBBUpI", "https://www.youtube.com/watch?v=qfjbt4DvO8Y",
						"https://www.youtube.com/watch?v=v2RmHH1M16w", "https://www.youtube.com/watch?v=eAPrv--96u4",
						"https://www.youtube.com/watch?v=fONvLV7sDGk", "https://www.youtube.com/watch?v=nHRH-96dpEI"];

const DEFAULT_SLIDER_SETTINGS = {
	speed: 350,
	infinite: false,
	className: 'designVideosSlider',
	cssEase: 'cubic-bezier(0.97, 0.99, 0.98, 0.97)',
	variableWidth: true,
	dots: true,
	arrows: true,
	slidesToShow: 1,
	slidesToScroll: 1,
	swipeToSlide: true,
	swipe: true
	};

const AccountPendingMsg = () => {

	return <div style={{padding: '10px 10px', textAlign: 'center', margin: '10px 0', background: '#f8931b', color: 'white'}}>
				Your account is pending approval! You cannot upload a design until your account is approved.
		</div>
}

const VideoSlider = ({title, videos}) => {
	const playerOpts = {width: '100%', height: '100%', 
								playerVars: {autoplay: 0}
							};

	const thumbnails = videos.map(url => AppUtil.fetchYoutubeVideoID(url))
							.map(videoId => 
							<div className="ytThumbnailHolder" key={videoId}>
									<YouTube key={videoId} videoId={videoId} opts={playerOpts} className="ytThumbnail"/>
							</div>);
	
	return <div>
			<h3>{title}</h3>
			<Slider {...DEFAULT_SLIDER_SETTINGS}>
				{thumbnails}
			</Slider>
		</div>
};


class PhoneNumberForm extends React.Component {

	constructor(props) {
		super(props);
		this.INIT_VALUES = {phoneNumber: ''};
		this.handleFormSubmission = this.handleFormSubmission.bind(this);
	}

	validationScheme() {
		const phoneNumberErrMsg = "Enter your 10 digit phone number.";

		return Yup.object().shape({
			phoneNumber: Yup.string().required(phoneNumberErrMsg).matches(/^[0-9]{10}$/, phoneNumberErrMsg)
		});
	}

	handleFormSubmission(value, {setSubmitting, resetForm}) {
		HttpService.updatePhone(value.phoneNumber, function(success) {
			setSubmitting(false);
			if(success) {
				resetForm();
				this.props.onClose();
			}
		}.bind(this));
	}


	render() {
		return <Modal closeOnOverlayClick={false} open={this.props.openPhoneNumberModal} 
						onClose={this.props.onClose} little
						classNames={{ overlay: 'phonenumber-overlay', modal: 'phonenumber-modal', closeIcon: 'phonenumber-close-icon' }} >
			<Formik initialValues={this.INIT_VALUES} onSubmit={this.handleFormSubmission}
							validationSchema={this.validationScheme} 
							render={({isSubmitting}) => {
							

				let submitBtn = 'Submit';
		
				if(isSubmitting === true)
					submitBtn = <span>Submitting <i className="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i></span>;

				return <RGForm>
					<h3 style={{margin: '10px 0px 20px 0'}}>We will contact you when your design is approved!</h3>
					<Input type="text" label="Provide your 10-digit phone number:" name="phoneNumber" />

					<SubmitButton color="primary" disabled={isSubmitting}>{submitBtn}</SubmitButton>
				</RGForm>
			}} />
		</Modal>	
	}
	
};

export const AddedImagePreview = ({id, file, onRemove}) => {
	return <div className="uploadedPreviewImg">
			<span className="closeUploadedPic" onClick={onRemove}><i className="fa fa-window-close-o" aria-hidden="true"></i></span>
			<SelectedImagePreview id={id} file={file} />
	</div>;
};

export const ImgUploadForm = ({inputId, onChange}) => {
	
	return <div className="imgUploadForm">
		<input style={{display: 'none'}} id={inputId} name={inputId} type="file" accept=".png, .jpg, .jpeg"
														onChange={onChange}/>
		<label htmlFor={inputId} className="imgUploader">
			<i className="fa fa-plus" aria-hidden="true"></i>
		</label>
	</div>
};


function isStepOneFilled(values) {
	if(!values.productType || !values.artworkType) 
		return false;

	if(values.productType === 'OTHER' && !values.otherCategory)
		return false;

	return true;
}

const StepOne = ({values, onArtWorkSelect}) => {
	const currentUser = SessionStore.getCurrentSession()? SessionStore.getCurrentSession().user: null;
	const isAdminUser = currentUser && currentUser.userType === AppConstants.USER_TYPE.ADMIN;

	const artworkType = ARTWORK_TYPES[values.artworkType];
	const productTypeOptions = Object.keys(PRODUCT_TYPES)
										.map(k => PRODUCT_TYPES[k])
										.filter(p => p.available === true)
										.filter(p => {
											return artworkType.supportedProductTypes.indexOf(p.val) >= 0;
										})
										.map(function(p){
													return {'label': p.label, 
															'value': p.val}
												});

	const productType = PRODUCT_TYPES[values.productType];
	
	return <div>
		<div className="submitStep flexRow">
			<span>Step</span> <span className="stepCount">1</span>
		</div>
		{isAdminUser &&
			<Input label="User Id: " name="userId" type="text" />
		}

		<div className="flexColumn">
			<label style={{margin: '0 0 10px 0', display: 'block'}}>Artwork Type:</label>

			<div className="flexRow">
				<RadioButton style={{flexGrow: '1'}} name="artworkType" value={ARTWORK_TYPES.DIGITAL_ART.val} 
														label={<span style={{color: '#596161'}}>{ARTWORK_TYPES.DIGITAL_ART.label}</span>} 
														checked={values.artworkType === ARTWORK_TYPES.DIGITAL_ART.val} 
														onChange={() => onArtWorkSelect(ARTWORK_TYPES.DIGITAL_ART.val)}
														/>
																

				<RadioButton style={{flexGrow: '1'}} name="artworkType" value={ARTWORK_TYPES.PHOTOGRAPH.val} 
								label={<span style={{color: '#596161'}}>{ARTWORK_TYPES.PHOTOGRAPH.label}</span>} 
								checked={values.artworkType === ARTWORK_TYPES.PHOTOGRAPH.val} 
								onChange={() => onArtWorkSelect(ARTWORK_TYPES.PHOTOGRAPH.val)}
								/>

				<RadioButton style={{flexGrow: '1'}} name="artworkType" value={ARTWORK_TYPES.PHYSICAL_ART.val} 
								label={<span style={{color: '#596161'}}>{ARTWORK_TYPES.PHYSICAL_ART.label}</span>} 
								checked={values.artworkType === ARTWORK_TYPES.PHYSICAL_ART.val} 
								onChange={() => onArtWorkSelect(ARTWORK_TYPES.PHYSICAL_ART.val)}
								/>

			</div>
			

			<br />
			<label style={{margin: '0 0 10px 0', display: 'block'}}>Select Product Type:</label>
			<ComboBox name="productType" value={values.productType} 
										options={productTypeOptions} 
										style={{flexGrow: '1', minWidth: '50%'}} />
			
			{productType && productType.psdTemplateUrl &&
				<span style={{background: '#f8921d', padding: '5px 10px', color: 'white', borderBottom: '2px solid rgb(61, 61, 61)'}}>
					<span><i className="fa fa-exclamation-circle" aria-hidden="true" /> Use <A href={productType.psdTemplateUrl} style={{textDecoration: 'underline', fontWeight: 'bold', color: '#3d3d3d'}}>{productType.label}.psd</A> to put your {artworkType.label} on a {productType.label}.</span>
				</span>
			}

			{productType && productType.val === 'OTHER' &&
				<Input label="Category: " name="otherCategory" type="text" />
			}
			
		</div>
	</div>
};


const StepTwo = ({values, designImage, productImages, onDesignUpdate, onProductImgsUpdate}) =>{
	if(!isStepOneFilled(values)) 
		return null;

	function onDesignUpload() {
		var file = document.getElementById("designImageFile").files[0];
		// setDesignImage(file);
		onDesignUpdate(file);
	}

	function clearDesignImg() {
		// setDesignImage(null);
		onDesignUpdate(null);
	}

	function onProductImgUpload(inputId) {
		const files = document.getElementById(inputId).files;

		var filesArr = [];
		for(var i = 0; i < files.length;i++)
			filesArr[i] = files[i];
		
		//the productImages state is read only
		var newProductImages = filesArr.concat(productImages);
		newProductImages.reverse();
		onProductImgsUpdate(newProductImages);
	}

	function clearProductImage(index) {
		//the productImages state is read only
		var newProductImages = productImages.concat([]);
		newProductImages.splice(index, 1);
		onProductImgsUpdate(newProductImages);
	}

	let imgConstraint = values.artworkType === ARTWORK_TYPES["PHOTOGRAPH"].val? PHOTOGRAPH_IMG_CONSTRAINT: DIGITAL_ART_IMG_CONSTRAINT;
	const imgConstraintInfo = <span style={{fontSize: '70%', color: 'black'}}>({imgConstraint})</span>;
	const productImgConstraintInfo = <span style={{fontSize: '70%', color: 'black'}}>({imgConstraint+", at least 1"})</span>;

	const productImagesPreview = productImages.map((img, i) => {
		var preview = <AddedImagePreview key={"productImage_"+i} id={"productImage_"+i} file={img} onRemove={() => clearProductImage(i)} />
		return preview;
	});

	const productUploaderSize = productImagesPreview? PRODUCT_IMAGES_LMT - productImagesPreview.length: PRODUCT_IMAGES_LMT;
	const productImgUploaders = [...Array(productUploaderSize).keys()].map(i => {
		const inputId = "productImageFile_"+i;
		return <ImgUploadForm inputId={inputId} key={inputId} onChange={() => onProductImgUpload(inputId)}/>
	});

	const artworkType = ARTWORK_TYPES[values.artworkType];
	const productType = AppConstants.PRODUCT_TYPES[values.productType];
	
	let learnMore = null;
	if(productType === AppConstants.PRODUCT_TYPES.T_SHIRT)
		learnMore = <small style={{fontSize: '90%'}}><A href="/faq#tshirtDesignLimitation">Learn More!</A></small>
	else if (productType === AppConstants.PRODUCT_TYPES.HOODIES)
		learnMore = <small style={{fontSize: '90%'}}><A href="/faq#hoodiesDesignLimitation">Learn More!</A></small>

	const productLabel = productType.val !== 'OTHER'? productType.label: values.otherCategory;
	return (
	<div>
		<div className="submitStep flexRow">
			<span>Step</span> <span className="stepCount">2</span>
		</div>

		{
			productType.previewRequired === true &&
			<div>
				<div id="designImgUploader" style={{minWidth: '100px', minHeight: '150px'}}>
					<label>
						<span>Add {artworkType.label} Image: </span>
						{imgConstraintInfo}
					</label>
					

					{!designImage &&
						<div style={{marginBottom: '20px'}}>
							<ImgUploadForm inputId="designImageFile" onChange={onDesignUpload}/>
							<Input id="designImage" name="designImage" mui='off' type="hidden" />
						</div>
					}
					

					{designImage &&
						<div className="flexRow" style={{marginBottom: '20px'}}>
							<AddedImagePreview id={"designImagePreview"} file={designImage} onRemove={clearDesignImg} />

						</div>
					}
				</div>
				
				<Separator />
			</div>
		}
		

		<div id="productImgUploader" style={{minWidth: '100px', minHeight: '150px'}}>
			<label>
				<span>Add {productLabel} Image: {learnMore}</span>
				{productImgConstraintInfo}
			</label>

			<div className="flexRow">
				{productImagesPreview &&
					<div className='flexRow'>
						{productImagesPreview}
					</div>
				}
				
				{
					productImgUploaders &&
					<div className="flexRow">
						{productImgUploaders}
					</div>
				}
				
			</div>
			<Input id="productImage" name="productImage" mui='off' type="hidden" />
		</div>
	</div>)
};


const StepThree = ({values, setFieldValue, productTagOptions, isSubmitting}) => {
	if(!isStepOneFilled(values)) 
		return null;

	let submitBtn = <span><i className="fa fa-cloud-upload" aria-hidden="true"></i> Submit</span>;
		
	if(isSubmitting === true)
		submitBtn = <span><i className="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i> Submitting</span>;
		
	return (
		<div>
			<div className="submitStep flexRow">
				<span>Step</span> <span className="stepCount">3</span>
			</div>

			{values.artworkType === ARTWORK_TYPES.PHYSICAL_ART.val && 
				<div>
					<Input label={<span>Price: (Rs.)</span>} name="productPrice" type="number" />
					<small style={{color: 'gray', marginBottom: '20px', display: 'block'}}>*MRP will later get calculated adding {AppConstants.APP_NAME} logistic and operational cost and VAT.</small>
				</div>
			}

			<Input label="Title: " name="title" type="text" />

			{values.artworkType === ARTWORK_TYPES.PHYSICAL_ART.val && 
				<ProductSizeInput values={values} setFieldValue={setFieldValue} />
			}
			

			<label style={{margin: '0 0 10px 0', display: 'block'}}>Select Tags or Enter new:</label>
			<ComboBox name="productTags" value={values.productTags} 
							options={productTagOptions} placeholder="Select Tags or Enter new (Optional)" 
							multi={true}
							closeOnSelect={true} 
							creatable={true} 
							/>

			<label style={{margin: '0 0 10px 0', display: 'block'}}>Description:</label>
			<TextArea placeholder={"Add a short info of your design (Optional)"}  name="description" rows="1" />

			

			<SubmitButton color="primary" disabled={isSubmitting}>{submitBtn}</SubmitButton>


			{values.artworkType === ARTWORK_TYPES.PHOTOGRAPH.val && 
				<div className="highlightInfo"><i className="fa fa-exclamation-circle" aria-hidden="true" /> You must also email your original photograph image at: <b>setocanvas@gmail.com</b>.</div>
			}

			{values.artworkType === ARTWORK_TYPES.DIGITAL_ART.val && 
				<div className="highlightInfo"><i className="fa fa-exclamation-circle" aria-hidden="true" /> You must also email a <b>300 resolution A4 size .png file (background less)</b> of your design at: <b>setocanvas@gmail.com</b>.</div>
			}

			
		</div>
	)
}

class SubmitProductForm extends React.Component {
	constructor(props) {
		super(props);

		this.validationScheme = this.validationScheme.bind(this);
		this.handleFormSubmission = this.handleFormSubmission.bind(this);
		this.INIT_VALUES = this.initializeValues();

		this.DESIGN_IMAGE = null;
		this.PRODUCT_IMAGES = [];

		this.state = {openPhoneNumberModal: false};
		this.handlePhoneNumberModalClose = this.handlePhoneNumberModalClose.bind(this);
		this.handleOnDesignImageUpload = this.handleOnDesignImageUpload.bind(this);
		this.handleOnProductImagesUpload = this.handleOnProductImagesUpload.bind(this);
		this.handleOnArtWorkSelect = this.handleOnArtWorkSelect.bind(this);
	}

	initializeValues() {
		let productType = '', artworkType = ARTWORK_TYPES['DIGITAL_ART'].val;

		const currentUser = SessionStore.getCurrentSession()? SessionStore.getCurrentSession().user: null;

		//set photograph and frame by default for Photographer user
		if(currentUser && currentUser.userType === AppConstants.USER_TYPE.PHOTOGRAPHER) {
			artworkType = ARTWORK_TYPES['PHOTOGRAPH'].val;
			productType = AppConstants.PRODUCT_TYPES['PHOTO_FRAME'].val;
		}

		return {userId:'', title: '', description: '',
						designImage: '', artworkType: artworkType, productType: productType, 
						productImage: '', productTags: [],
						productPrice: '',
						otherCategory: '',
						productSizes: ''
				}
	}

	clearUploadedFiles() {
		this.DESIGN_IMAGE = null;
		this.PRODUCT_IMAGES = [];
	}

	handleOnDesignImageUpload(designImage, setFieldValue) {
		this.DESIGN_IMAGE = designImage;
		setFieldValue('designImage', designImage? '1': '');//set a non-empty string to indicate the value has been set
	}

	handleOnProductImagesUpload(productImages, setFieldValue) {
		this.PRODUCT_IMAGES = productImages;
		setFieldValue('productImage', productImages.length > 0? '1': '');//set a non-empty string to indicate the value has been set
	}

	handleOnArtWorkSelect(selectedArtwork, currentProductType, setFieldValue) {
		setFieldValue('artworkType', selectedArtwork);
		setFieldValue('productType', '');
	}

	validationScheme() {
		return Yup.object().shape({
			title: Yup.string().required("Enter a title that defines your artwork"),
			designImage: Yup.string().when('productType', (productType, schema) => {
								return (productType && AppConstants.PRODUCT_TYPES[productType].previewRequired)? Yup.string().required("Add your artwork image"): Yup.string();
						}),
			artworkType: Yup.string().required("Select artwork type"),
			productType: Yup.string().required("Select a product type"),
			productTags: Yup.array().max(5, "Maximum 5 tags allowed"),
			productImage: Yup.string().required("Add product image with your artwork"),
			otherCategory: Yup.string().when('productType', (productType, schema) => {
				return (productType && productType === 'OTHER')? Yup.string().required("Enter the category your Art belongs to"): Yup.string();
			}),
			productPrice: Yup.string().when('artworkType', (artworkType, schema) => {
				return (artworkType && AppConstants.ARTWORK_TYPES.PHYSICAL_ART.val === artworkType)? Yup.string().required("Enter your product price"): Yup.string();
			}),
			productSizes: Yup.mixed().when('artworkType', (artworkType, schema) => {
				if(artworkType && AppConstants.ARTWORK_TYPES.PHYSICAL_ART.val === artworkType) {
					return Yup.mixed().required("Enter available sizes of your Artwork");
				} else
					return Yup.mixed();
			})
		});
	}

	handleFormSubmission(value, {setSubmitting, resetForm, setFieldValue}) {
		const selectedArtWorkType = value.artworkType;
		const selectedProductType = value.productType;

		let title = value.title;

		if(value.otherCategory !== '')
			title += " - "+value.otherCategory;

		const addProductRequest = {title: title, description: value.description, 
								artworkType: selectedArtWorkType, productType: selectedProductType,
								productTags: value.productTags};


		if(value.productPrice)
			addProductRequest.productPrice = value.productPrice;
		
		
		if(value.userId)
			addProductRequest['userId'] = value.userId;
	
		
		if(value.productSizes)
			addProductRequest['sizeMetaData'] = value.productSizes;
			
		HttpService.addProduct(addProductRequest, this.DESIGN_IMAGE, this.PRODUCT_IMAGES,
			function(success) {
					if(!success) {
						setSubmitting(false);
						return;
					}

					
					//check if it needs to upgrade to designer or not
					const currentUser = SessionStore.getCurrentSession().user;
					if(currentUser.userType === AppConstants.USER_TYPE.REGULAR) {
						HttpService.upgradeToDesigner(function(success) {
							this.doneDesignSubmission(success, setSubmitting, resetForm);

							setFieldValue('artworkType', selectedArtWorkType);
							setFieldValue('productType', selectedProductType);
						}.bind(this));
					} else {
						this.doneDesignSubmission(true, setSubmitting, resetForm);
						setFieldValue('artworkType', selectedArtWorkType);
						setFieldValue('productType', selectedProductType);
					}
									
				}.bind(this));
	}

	doneDesignSubmission(success, setSubmitting, resetForm) {
		setSubmitting(false);

		if(success) {
			this.clearUploadedFiles();
			resetForm();
			AppUtil.scrollToElement("submitProductForm", {behavior: 'smooth'});
			const currentUser = SessionStore.getCurrentSession().user;

			if(!currentUser.phoneNumber) {
				//show phone number modal
				this.setState({openPhoneNumberModal: true});
			}
		}
	}

	handlePhoneNumberModalClose() {
		this.setState({openPhoneNumberModal: false});
	}

	render() {
		const productTagOptions = AppConstants.DEFAULT_PRODUCT_TAGS.map(function(v){
			return {'label': v.toUpperCase(), 'value': v.toLowerCase()}
		});
		
		
		const currentUser = SessionStore.getCurrentSession()? SessionStore.getCurrentSession().user: null;
		return <div id="submitProductForm">
					{currentUser && currentUser.userStatus === "PENDING_APPROVAL" && <AccountPendingMsg /> }
					
					<h3>Submit Your Design</h3>
					<Formik initialValues={this.INIT_VALUES} onSubmit={this.handleFormSubmission}
							validationSchema={this.validationScheme} 
							render={({values, setFieldValue, isSubmitting}) => {
						return (
								<RGForm>
									<StepOne values={values} onArtWorkSelect={(selectedArtWork) => {
										this.handleOnArtWorkSelect(selectedArtWork, values.productType, setFieldValue);
									}}/>
								
									<StepTwo values={values} designImage={this.DESIGN_IMAGE} productImages={this.PRODUCT_IMAGES} 
									onDesignUpdate={(designImg) => {
										this.handleOnDesignImageUpload(designImg, setFieldValue);
									}} onProductImgsUpdate={(productImages) => {
										this.handleOnProductImagesUpload(productImages, setFieldValue);
									}}/>

									<StepThree values={values} setFieldValue={setFieldValue} productTagOptions={productTagOptions} isSubmitting={isSubmitting} />
								</RGForm>
						)}} />

					<div id="designVideos">
						<VideoSlider title="Canvas To Cash - Tutorials" videos={CANVAS_TO_CASH_VIDEOS} />
						<br />
						<VideoSlider title="Other Videos" videos={DESIGN_VIDEOS} />
					</div>
					<PhoneNumberForm openPhoneNumberModal={this.state.openPhoneNumberModal} onClose={this.handlePhoneNumberModalClose} />
			</div>
	}
}


export default Radium(SubmitProductForm);




// WEBPACK FOOTER //
// ./src/views/designer/SubmitProductForm.js